import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why programmers work at night",
  "description": "",
  "published": "2011-12-15T00:00:00.000Z",
  "redirect_from": ["/blog/?p=3196"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A popular joke goes: `}<em parentName="p">{`Programmers are machines that transform coffee into code.`}</em></p>
    <p>{`Obviously this aludes to the copious amounts of caffeine that have become pretty much the staple of developer culture to the point I find it surprising that energy drink companies haven't started sponsoring developers.`}</p>
    <p>{`Develop an argument around distractions and ability to schedule large swaths of time to actually get anything done because distractions are actually a much lesser problem than anticipation of abstractions - it being difficult to focus on a task if you know you will be distracted in an hour and that working is somehow made easier when you can just code away seemingly without a hard limit.`}</p>
    <p>{`Perhaps tie this into the difficulty of predicting how long a programming task is actually going to take.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      